module.exports = __webpack_public_path__ + "assets/otc-settlement-icon.25bd77de.svg";